import { useEffect, useRef } from "react";

import { useHalloween2026 } from "@/hooks/useHalloween2026";
import { mountHomeOverlay } from "@/libs/halloween-2026/home-overlay";

/**
 * 할로윈 2026 홈 히어로 낙하 오버레이 (#6061 H4) — 기간 중 히어로 위로 호박 · 유령 · 사탕이 떨어진다.
 *
 * 히어로 안에서 **배경(영상 · 그라디언트) 위, 카피 · CTA 아래**에 둔다 — 시안 레이어 이름이
 * 「overlay (sprites · pointer-events none · 히어로 카피·CTA 비가림)」이다. 스프라이트는 히어로 60% 지점에서
 * 사라져 하단 카피까지 내려오지 않는다.
 *
 * ⚠️ `isolate` — 스프라이트마다 깊이용 z-index(0~100)가 붙는다. 이 레이어가 쌓임 맥락을 만들지 않으면
 * 그 값이 히어로의 형제(카피 블록, z-index auto)와 겨뤄 카피 위로 올라간다.
 */
export function Halloween2026HeroOverlay() {
  const active = useHalloween2026();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!active || !ref.current) return;
    return mountHomeOverlay(ref.current);
  }, [active]);

  if (!active) return null;
  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 isolate overflow-hidden"
    />
  );
}
